import React from 'react';
import { motion } from 'framer-motion';

const BenefitCard = ({ icon: Icon, title, iconColor = "#3338A0", bgColor = "#FC8D89" }) => {
  return (
    <motion.article
      className="relative flex flex-col items-center justify-center w-full
                 max-w-[280px] h-[280px] mx-auto
                 max-sm:max-w-[160px] max-sm:h-[160px]
                 max-xs:max-w-[140px] max-xs:h-[140px]"
      whileHover={{ scale: 1.05 }}
      transition={{ duration: 0.3 }}
    >
      {/* Circle background */}
      <div className="relative w-[260px] h-[260px] bg-white border-[3px] border-[#FC8D89] rounded-full flex flex-col items-center justify-center p-6 shadow-lg hover:shadow-xl transition-shadow duration-300
                      max-sm:w-[150px] max-sm:h-[150px] max-sm:border-2 max-sm:p-3
                      max-xs:w-[130px] max-xs:h-[130px] max-xs:p-2">

        {/* Icon container */}
        <div className="relative mb-6 max-sm:mb-3 max-xs:mb-2">
          <div
            className="w-[100px] h-[100px] rounded-full flex items-center justify-center shadow-md
                       max-sm:w-[50px] max-sm:h-[50px]
                       max-xs:w-[40px] max-xs:h-[40px]"
            style={{ backgroundColor: bgColor }}
          >
            {Icon && (
              <Icon
                className="w-12 h-12 max-sm:w-6 max-sm:h-6 max-xs:w-5 max-xs:h-5"
                style={{ color: iconColor }}
              />
            )}
          </div>
        </div>

        {/* Title */}
        <h3 className="text-lg font-bold text-slate-900 text-center leading-tight max-w-[200px]
                       max-sm:text-sm max-sm:max-w-[120px] max-sm:leading-tight max-sm:font-medium
                       max-xs:text-xs max-xs:max-w-[100px] max-xs:font-medium">
          {title}
        </h3>
      </div>
    </motion.article>
  );
};

export default BenefitCard;




// import React from 'react';
// import { motion } from 'framer-motion';

// const BenefitCard = ({ icon: Icon, title, iconColor = "#3338A0", bgColor = "#FC8D89" }) => {
//   return (
//     <motion.article
//       className="relative flex flex-col items-center justify-center w-full max-w-[280px] h-[280px] mx-auto"
//       whileHover={{ scale: 1.05 }}
//       transition={{ duration: 0.3 }}
//     >
//       {/* Circle background */}
//       <div className="relative w-[260px] h-[260px] bg-white border-[3px] border-[#FC8D89] rounded-full flex flex-col items-center justify-center p-6 shadow-lg hover:shadow-xl transition-shadow duration-300">

//         {/* Icon container */}
//         <div className="relative mb-6">
//           <div
//             className="w-[100px] h-[100px] rounded-full flex items-center justify-center shadow-md"
//             style={{ backgroundColor: bgColor }}
//           >
//             <Icon
//               className="w-12 h-12"
//               style={{ color: iconColor }}
//             />
//           </div>
//         </div>

//         {/* Title */}
//         <h3 className="text-lg font-bold text-slate-900 text-center leading-tight max-w-[200px]">
//           {title}
//         </h3>
//       </div>
//     </motion.article>
//   );
// };

// export default BenefitCard;
